import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import type { MechanicListQuery } from "../api/client";
import { useMechanicsQuery } from "../api/queries";
import { MechanicsFilter, type MechanicsSearch } from "../ui/MechanicsFilter";
import { MechanicsStatsCards } from "../ui/MechanicsStatsCards";
import { MechanicsTable } from "../ui/MechanicsTable";
import { MechanicsToolbar } from "../ui/MechanicsToolbar";

export function MechanicOnboardingPage() {
  const nav = useNavigate({ from: "/app/mechanics" });
  const search = useSearch({ from: "/app/mechanics" }) as MechanicsSearch;

  const query: MechanicListQuery = {
    offset: search.offset ?? 0,
    limit: search.limit ?? 20,
    status: search.status ?? "all",
    q: search.q,
    sortBy: search.sortBy,
    sortOrder: search.sortOrder,
  };

  const list = useMechanicsQuery(query);
  const total = list.data?.meta?.total ?? 0;
  const offset = search.offset ?? 0;
  const limit = search.limit ?? 20;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຄິວລົງທະບຽນຊ່າງ" },
          ]}
        />
      </Header>

      <Main>
        <MechanicsToolbar />
        <MechanicsStatsCards />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <MechanicsFilter />
          <MechanicsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={offset}
            limit={limit}
            totalCount={total}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sortBy}
            sortOrder={search.sortOrder}
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  offset: 0,
                  sortBy: id as "createdAt" | "displayName",
                  sortOrder: desc ? "desc" : "asc",
                },
              })
            }
            onViewDetails={(id) =>
              nav({ to: "/app/mechanics/$id", params: { id } })
            }
          />
        </div>
      </Main>
    </>
  );
}
